import { Record } from 'immutable';
export default Record([{
  _id: null,
  rates: []
}]);